import { AuthProvider } from "providers/AuthProvider";
import MyRoutes from "./routers";

function App() {
  return (
    <>
      <AuthProvider>
          <div className="bg-[#f8f8f8] text-base dark:bg-neutral-900/95 text-neutral-900 dark:text-neutral-200 font-body">
            <MyRoutes />
          </div>
      </AuthProvider>
    </>
  );
}

export default App;
